'use client';

import { useEffect } from 'react';
import { ddReportHydrationMeasured } from '@/utils/datadog';
import { HYDRATION_END_MARK, HYDRATION_MEASURE, HYDRATION_START_MARK } from './hydration-marks.constants';

/**
 * Marks the first committed root effect. Together with the parser-time start
 * mark in the root layout, this provides a stable lab definition of hydration:
 * body parsing start → root React effect.
 */
export const HydrationMarker = () => {
    useEffect(() => {
        if (performance.getEntriesByName(HYDRATION_MEASURE, 'measure').length > 0) {
            return;
        }

        if (performance.getEntriesByName(HYDRATION_START_MARK, 'mark').length === 0) {
            performance.mark(HYDRATION_START_MARK, { startTime: 0 });
        }
        performance.mark(HYDRATION_END_MARK);
        performance.measure(HYDRATION_MEASURE, HYDRATION_START_MARK, HYDRATION_END_MARK);

        const [measure] = performance.getEntriesByName(HYDRATION_MEASURE, 'measure');
        if (measure && Number.isFinite(measure.duration)) {
            ddReportHydrationMeasured(measure.duration);
        }
    }, []);

    return null;
};
